module.exports = __webpack_public_path__ + "static/media/icon_checkin.84850bfd.svg";